import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const CheckFilledIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14m-5.46-13.63a.8.8 0 1 0-1.08 1.18l4 3.667a.8.8 0 0 0 1.128-.047l7.804-8.45a.8.8 0 1 0-1.176-1.086L13.953 19.5z"
      clipRule="evenodd"
    />
  </IconV2>
);

export default CheckFilledIcon;
